package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ContentFlag {
    @SerialName("nudity") NUDITY,
    @SerialName("violence") VIOLENCE,
    @SerialName("hate") HATE,
    @SerialName("spam") SPAM,
    @SerialName("drugs") DRUGS,
    @SerialName("weapons") WEAPONS
}
